var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"p-0"},[_c('b-dropdown',{attrs:{"variant":"link","size":"lg","dropleft":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fe fe-more-vertical"})]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }